export interface PaletteCommand {
  id: string;
  label: string;
  description?: string;
  kind: 'navigate';
  target: string;
}

export const builtInCommands: PaletteCommand[] = [
  { id: 'nav.orders', label: 'Go to Orders', kind: 'navigate', target: '/orders' },
  { id: 'nav.shipments', label: 'Go to Shipments', kind: 'navigate', target: '/shipments' },
  { id: 'nav.inventory', label: 'Go to Inventory', kind: 'navigate', target: '/inventory' },
  { id: 'nav.products', label: 'Go to Products', kind: 'navigate', target: '/products' },
  { id: 'nav.warehouse', label: 'Go to Warehouses', kind: 'navigate', target: '/warehouses' },
];
